"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const variantStylesMap = {
    h900: 'text-h900 font-bold',
    h800: 'text-h800 font-bold',
    h700: 'text-h700 font-bold',
    h600: 'text-h600 font-bold',
    h500: 'text-h500 font-bold',
    h400: 'text-h400 font-bold',
    h300: 'text-h300 font-bold',
    h200: 'text-h200 font-bold',
    h100: 'text-h100 font-bold',
    'eyebrow-1': 'text-eyebrow-1 font-bold',
    'subtitle-1': 'text-subtitle-1 font-normal',
    'body-large': 'text-body-large font-normal',
    'body-medium': 'text-body-medium font-normal',
    'body-small': 'text-body-small font-normal',
};
const Typography = ({ children, as = 'span', className = '', 
// Base style
variant = 'body-medium', }) => {
    const Component = as;
    return ((0, jsx_runtime_1.jsx)(Component, Object.assign({ className: (0, classnames_1.default)(variantStylesMap[variant], className) }, { children: children })));
};
exports.Typography = Typography;
//# sourceMappingURL=Typography.js.map